module.exports = __webpack_public_path__ + "img/ps.dab5110b.svg";